import { useEffect, useState } from 'react';
import { useDispatch, useSelector} from 'react-redux'
import { makeStyles } from '@material-ui/core/styles';
import { Divider } from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { getUserPreference } from "../../../utilities/common";
import ConditionalSearch from './ConditionalSearch';
import { DataGrid } from '@material-ui/data-grid';
import FullscreenLoading from '../../Common/FullscreenLoading';
import { openEditDriverModal } from '../../../reducers/uiSlice';
import TableTooltip from '../../Common/TableTooltip';

const useStyles = makeStyles((theme)=> ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),    
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },  
    searchFab: {
        color: green[500],
        width: 40, 
        height: 40
    },
    table: {
        minWidth: 700,
        border: 1,    
    },  
}))

export default function DriverEditRecordList() {
    const {t} = useTranslation('editDriver');

    const sectionList = {
        '-1': {
            name: t('any')
        },
        '0': {
            name: t('all_'),
            text: t('profile') + ', ' + t('driver_information') + ', ' + t('payout_method') + ', ' + t('documents')
        },
        '1': {
            name: t('profile'),
            text: t('profile')
        },
        '2': {
            name: t('driver_information'),
            text: t('driver_information')
        },
        '3': {
            name: t('payout_method'),
            text: t('payout_method')
        },
        '4': {
            name: t('documents'),
            text: t('documents')
        }
    }

    const columns = [
        {
            field: 'id', 
            hide: true
        },
        {
            field: 'driver_id', 
            headerName: t('driver_id'), 
            headerAlign: 'center',
            flex: 1,
            align: 'center'
        },
        {
            field: 'username', 
            headerName: t('username'), 
            flex: 1,
            headerAlign: 'center', 
            sortable: false,
            align: 'center'
        },
        {
            field: 'phone', 
            headerName: t('phone_'), 
            flex: 1, 
            headerAlign: 'center', 
            sortable: false,
            align: 'center'
        },
        {
            field: 'firstname', 
            headerName: t('firstname'), 
            flex: 1, 
            headerAlign: 'center', 
            sortable: false,
            align: 'center'
        },
        {
            field: 'lastname', 
            headerName: t('lastname'), 
            flex: 1, 
            headerAlign: 'center', 
            sortable: false,
            align: 'center'
        },
        {
            field: 'modified_time', 
            headerName: t('modified_time'), 
            flex: 1, 
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'data_type', 
            headerName: t('sections_edited'), 
            headerAlign: 'center',
            flex:1, 
            align: 'center',
            renderCell: (params) => (
                <TableTooltip value={sectionList[params.value].text} />
            ),
          align: 'center'
        }
    ];

    const list = useSelector(state => state.driver.logDriverOperations);
    const openModal = useSelector(openEditDriverModal) || false;
    
    const [driverList, setDriverList] = useState([]);

    function createRows(){
        return driverList.map((row, index) => {
            const { ...rest } = row
            return {
                id: index,
                ...rest
            }
        })
    }


    useEffect(() => {
        setDriverList(list);
    }, [list])

    useEffect(() => {
        if(openModal) {
            setDriverList([]);
        }
    }, [openModal])

    return (
        <>
            <ConditionalSearch 
                sectionList={sectionList}
            />
            <Divider></Divider>
            <DataGrid
                columns={columns}
                rows={createRows()}
                pageSize={20}
                alignItems="center"
                style={{height: '70vh', margin: 16}}
            />
        </>
    );
}
